import { useState } from 'react';
import EnrollmentModal from './EnrollmentModal';

export default function ProgramInfo() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Información del Programa Completo
              </h2>
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-book-open-fill text-teal-600"></i>
                    Duración Total
                  </h3>
                  <p className="text-gray-700">
                    360 horas de formación completa distribuidas en 4 módulos principales, con contenido teórico-práctico y evaluaciones continuas.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-calendar-fill text-teal-600"></i>
                    Modalidad
                  </h3>
                  <p className="text-gray-700">
                    100% online con acceso 24/7 a la plataforma. Estudia a tu ritmo con tutorías personalizadas y soporte continuo de profesionales expertos.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-award-fill text-teal-600"></i>
                    Formación Adaptada al INCUAL
                  </h3>
                  <p className="text-gray-700">
                    Formación adaptada al Instituto Nacional de las Cualificaciones según RD 545/2023 y RD 917/2024, nivel de cualificación 2, válida en toda España y reconocida en la Unión Europea.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-shield-check-fill text-teal-600"></i>
                    Contenido Incluido
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>Conocimientos de riesgos laborales</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>Bienestar animal</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>Vídeos paso a paso</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>Material didáctico descargable</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>Cuestionarios de evaluación</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Metodología de Aprendizaje
              </h2>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold text-xl">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Contenido Multimedia</h3>
                    <p className="text-gray-700">
                      Accede a vídeos profesionales paso a paso, fotografías detalladas y material didáctico interactivo diseñado por expertos en adiestramiento canino.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold text-xl">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Práctica Guiada</h3>
                    <p className="text-gray-700">
                      Realiza ejercicios prácticos con casos reales, simulaciones y actividades que te prepararán para situaciones profesionales del día a día.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold text-xl">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Evaluación Continua</h3>
                    <p className="text-gray-700">
                      Completa cuestionarios interactivos, pruebas de conocimiento y evaluaciones prácticas que garantizan tu progreso y comprensión.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold text-xl">4</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Soporte Personalizado</h3>
                    <p className="text-gray-700">
                      Recibe tutorías personalizadas, resuelve dudas con profesionales expertos y participa en una comunidad activa de estudiantes.
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-teal-600 to-teal-800 rounded-2xl p-8 text-white mt-8">
                  <h3 className="text-2xl font-bold mb-4">¿Listo para comenzar?</h3>
                  <p className="text-teal-50 mb-6">
                    Inscríbete ahora y obtén acceso inmediato a todo el contenido formativo. Comienza tu carrera profesional en adiestramiento canino hoy mismo.
                  </p>
                  <button 
                    onClick={() => setIsModalOpen(true)}
                    className="w-full rounded-full bg-white px-6 py-3 text-base font-semibold text-teal-600 shadow-lg hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Inscribirse Ahora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <EnrollmentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}